export default __webpack_public_path__ + "static/media/logo_swap1.941ac026.png";